import { BASE_URL } from '../constants/config';

let accessToken = null;
let onUnauthorized = null;
let inflightRefresh = null;

export const setAccessToken = (token) => { accessToken = token; };
export const clearAccessToken = () => { accessToken = null; };
export const setOnUnauthorized = (cb) => { onUnauthorized = cb; };

const tryRefresh = () => {
  if (inflightRefresh) return inflightRefresh;

  inflightRefresh = (async () => {
    const refreshToken = localStorage.getItem('refreshToken');
    if (!refreshToken) throw new Error('no refresh token');

    const response = await fetch(`${BASE_URL}/auth/refresh`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ refreshToken }),
    });

    if (!response.ok) throw new Error('refresh failed');

    const data = await response.json();
    accessToken = data.token;
    return data.token;
  })().finally(() => { inflightRefresh = null; });

  return inflightRefresh;
};

export const apiFetch = async (path, options = {}) => {
  const execute = (token) =>
    fetch(`${BASE_URL}${path}`, {
      ...options,
      headers: { ...options.headers, Authorization: `Bearer ${token}` },
    });

  let response = await execute(accessToken);

  if (response.status === 401) {
    try {
      const newToken = await tryRefresh();
      response = await execute(newToken);
    } catch {
      if (onUnauthorized) onUnauthorized();
      throw new Error('Sessione scaduta. Effettua nuovamente il login.');
    }
  }

  return response;
};
